import { z } from 'zod';
import { apiClient } from '@api/client';
import { districtOptionSchema, type DistrictOption } from './schema';

const optionsResponseSchema = z.object({
  statusCode: z.number(),
  message: z.string(),
  data: z.array(districtOptionSchema).nullable(),
  error: z.string().nullable().optional(),
});

export async function getDistrictOptions(): Promise<DistrictOption[]> {
  const response = await apiClient.get('/districts/options');
  const parsed = optionsResponseSchema.safeParse(response.data);
  if (!parsed.success || !parsed.data.data) {
    throw new Error(parsed.success ? 'Empty response' : parsed.error.message);
  }
  return parsed.data.data;
}
